import Form from './Component/Form';
import './App.css';
import './Component/Style.css'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Form/>
      </header>
    </div>
  );
}

export default App;
